import React from "react";
import styled from "styled-components";
import VendorCard from "./VendorCard";
import { useLang } from "../i18n/LanguageContext";

export default function VendorGrid({ vendors, showHeader = true }) {
  const { t } = useLang();
  return (
    <>
      {showHeader && (
        <Head>
          <h2>{t("section.title")}</h2>
          <span className="count">
            {vendors.length} {t("section.results")}
          </span>
        </Head>
      )}
      {vendors.length === 0 ? (
        <Empty>{t("empty")}</Empty>
      ) : (
        <Grid>
          {vendors.map((v, i) => (
            <VendorCard key={v.id} vendor={v} index={i} />
          ))}
        </Grid>
      )}
    </>
  );
}

const Head = styled.div`
  max-width: ${({ theme }) => theme.maxWidth};
  margin: 0 auto;
  padding: clamp(40px, 6vw, 64px) clamp(20px, 5vw, 40px) 8px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  h2 {
    font-family: ${({ theme }) => theme.font.display};
    font-weight: 500;
    font-size: clamp(26px, 3.6vw, 38px);
    letter-spacing: -0.01em;
  }
  .count { font-size: 13px; color: ${({ theme }) => theme.colors.inkSoft}; white-space: nowrap; }
`;

const Grid = styled.main`
  max-width: ${({ theme }) => theme.maxWidth};
  margin: 0 auto;
  padding: 24px clamp(20px, 5vw, 40px) clamp(50px, 8vw, 90px);
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: 900px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 560px) { grid-template-columns: 1fr; }
`;

const Empty = styled.div`
  max-width: ${({ theme }) => theme.maxWidth};
  margin: 0 auto;
  padding: 40px clamp(20px, 5vw, 40px) 90px;
  color: ${({ theme }) => theme.colors.inkSoft};
`;
